import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { scrollToElement } from '../ui';

type UseScrollToHashElementParams = {
  isReady: boolean;
};

const getHashFromPath = (asPath: string) => {
  const hashIndex = asPath.indexOf('#');
  if (hashIndex === -1) {
    return null;
  }

  return asPath.substring(hashIndex + 1);
};

const useScrollToHashElement = ({ isReady }: UseScrollToHashElementParams) => {
  const { asPath } = useRouter();

  useEffect(() => {
    const hash = getHashFromPath(asPath);

    if (!isReady || !hash) {
      return;
    }

    scrollToElement(document.getElementById(hash));
  }, [asPath, isReady]);
};

export default useScrollToHashElement;
